import React from "react";
import { useHistory } from "react-router-dom";

export const COBRECCelda = ({ titulo, type, data, linea, cartera, permisos }) => {
    const history = useHistory();
  const valor = (prop) => {
    try {
      return formatmiles(data[0][prop]);
    } catch (error) {
      return 0;
    }
  };
  const Getporcentaje = () => {
    try {
      return Math.floor(data[0].porcentaje);
    } catch (error) {
      return 0;
    }
  };
  const formatmiles = (number) => {
    if (number <= 0) {
      number = 0;
    }
    return Math.floor((number ?? 0) / 1000).toLocaleString("en-US");
  };
  return (
    <div className="container-barra-celda" onClick={() =>
      history.push(
        "/Creditoycobranza/GestionClientes", {
          linea: linea,
          cartera: cartera,
          permisos
        })
    }>
      <div className="container-barra-celda-titulo">{titulo}</div>
      <div className="container-barra-celda-contenido">
        {type === "A" ? (
          <div
            class="pie-chart-activa"
            style={{ "--percentage": Getporcentaje() }}
          >
            <span>{Getporcentaje()}%</span>
          </div>
        ) : type === "P" ? (
          <div class="pie-chart-pv" style={{ "--percentage": Getporcentaje() }}>
            <span>{Getporcentaje()}%</span>
          </div>
        ) : (
          <div
            class="pie-chart-ven"
            style={{ "--percentage": Getporcentaje() }}
          >
            <span>{Getporcentaje()}%</span>
          </div>
        )}
        <div className="container-barra-celda-info">
          <div>Importe</div>
          <strong>${valor("objetivo")}</strong>
          <div>Cobrado</div>
          <strong>${valor("recuperado")}</strong>
        </div>
      </div>
    </div>
  );
};
